import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/http-client';
import { DEFAULT_QUERY_OPTIONS } from '@/shared/api/query-config';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            ...DEFAULT_QUERY_OPTIONS,
            retry: (failureCount, error) => {
                if (error instanceof ApiError && error.status === 401) return false;
                return failureCount < DEFAULT_QUERY_OPTIONS.retry;
            },
        },
    },
});
